import { Component, OnInit, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { QueovalItemModel, BreadDik, QueovalItem, QResult } from '../../../../models';
import { ClientConvention, ConventionModel } from '../../../../models/formation/convention.models';
import { BreadcrumbService, CoreService, HttpService } from '../../../../services';
import { StageService } from '../services/stage-modal.service';
import { ConventionService } from './convention.service';

@Component({
  selector: 'queoval-stage-convention',
  templateUrl: './convention.component.html',
  styleUrls: ['./convention.component.css'],
  providers: [ConventionService],
})

export class ConventionComponent implements OnInit {

  constructor(
    public http: HttpService,
    public indParam: CoreService,
    private conventionService: ConventionService,
    private stageService: StageService,
    private breadCrumb: BreadcrumbService,
  ) { }

  public clients: Array<ClientConvention> = [];
  public inputClientsValue: string = '';
  /** texte dans la combo client (si clients > 10) entre le nom client et le nombre de conventions */
  public datalistOptionSplit1: string = ' - Conventions: ';
  /** texte dans la combo client (si clients > 10) entre le nombre de conventions et l'adresse */
  public datalistOptionSplit2: string = ' - ';

  public ngOnInit(): void {
    // récupère la liste des entités de facturations autorisées pour la personne connectée et l'entité de facturation sur le client
    this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/ENTITE_FACTURATION/0|0`).subscribe(
      (result: QueovalItemModel) => {
        this.conventionService.EntiteFact = result.queovalItemList;
      });

    //récupération de la liste des clients du stage (Ident, RaisoCli, CpVille, liste Ident conventions)
    this.http.getHttp<QResult<ConventionModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/INIT/${this.stageService.Stage.Ident}`).subscribe(
      (result: QResult<ConventionModel>) => {
        this.clients = result.Value.Clients.sort((a: ClientConvention, b: ClientConvention) => {
          if (a.LinkedToStage && !b.LinkedToStage)
            return -1;
          else if (!a.LinkedToStage && b.LinkedToStage)
            return 1;
          return a.RaisoCli.localeCompare(b.RaisoCli);
        });
        // compte le nombre de conventions sauvegardées
        this.clients.map(client => {
          client.NbConventions = client?.Conventions ? client.Conventions.filter(c => c.Ident && c.Ident != '0').length : 0;
          return client;
        });

        this.conventionService.dossiers = result.Value.Dossiers;
        //ouvre le client si il n'y en a qu'un attaché au stage
        if (this.clients.length == 1) {
          this.clients[0].displayed = true;
          this.conventionService.OnSelectClient(this.clients[0], this.stageService.Stage.Ident).subscribe();
        }
        //ouvre le client si on revient du breadcrumb et qu'un idClient était renseigné
        const paramIdClient: BreadDik | undefined = this.breadCrumb.Params.params.find(param => param.key == 'idClient');
        const paramIdConvention: BreadDik | undefined = this.breadCrumb.Params.params.find(param => param.key == 'idConvention');
        const paramFilterClient: BreadDik | undefined = this.breadCrumb.Params.params.find(param => param.key == 'filterClient');
        this.breadCrumb.Params.params = [];
        if (paramIdClient && paramIdClient.value) {
          const selectedClient = this.clients.find(c => c.Ident == paramIdClient.value);
          if (selectedClient) {
            selectedClient.displayed = true;
            this.conventionService.OnSelectClient(selectedClient, this.stageService.Stage.Ident).subscribe(() => {
              if (paramFilterClient)
                this.inputClientsValue = selectedClient?.RaisoCli + this.datalistOptionSplit1 + (selectedClient?.Conventions ? selectedClient.Conventions.length : 0) + this.datalistOptionSplit2 + selectedClient.CpVille;
              //ouvre la convention si on revient du breadcrumb et qu'un IdConvention était renseigné
              if (paramIdConvention && paramIdConvention.value) {
                const selectedConvention = selectedClient.Conventions.find(c => c.Ident == paramIdConvention.value);
                if (selectedConvention) {
                  selectedConvention.displayed = true;
                }
              }
            });
          }
        }
        else if (paramIdConvention && paramIdConvention.value) {
          //ouvre le client et la convention si on passe un idConvention
            const selectedClient = this.clients.find(c => c.Conventions.some(conv => conv.Ident == paramIdConvention.value));
            if (selectedClient) {
              selectedClient.displayed = true;
              this.conventionService.OnSelectClient(selectedClient, this.stageService.Stage.Ident).subscribe(() => {
                if (paramFilterClient)
                  this.inputClientsValue = selectedClient?.RaisoCli + this.datalistOptionSplit1 + (selectedClient?.Conventions ? selectedClient.Conventions.length : 0) + this.datalistOptionSplit2 + selectedClient.CpVille;
                //ouvre la convention si on revient du breadcrumb et qu'un IdConvention était renseigné
                if (paramIdConvention && paramIdConvention.value) {
                  const selectedConvention = selectedClient.Conventions.find(c => c.Ident == paramIdConvention.value);
                  if (selectedConvention) {
                    selectedConvention.displayed = true;
                  }
                }
              });
            }
        }
        this.OpenAll();
          return this.clients;
      });
  }

  public ClientFilter(pClient: Array<ClientConvention>, value: string): Array<ClientConvention> {
    if (!value)
      return pClient;
    return pClient.filter(client => (client?.RaisoCli + this.datalistOptionSplit1 + (client?.Conventions ? client.Conventions.length : 0) + this.datalistOptionSplit2 + client.CpVille).toLowerCase().includes(value.toLowerCase()))
  }

  public OpenAll(): void {
    this.clients.map(client => {
      client.displayed = true;
      this.conventionService.OnSelectClient(client, this.stageService.Stage.Ident).subscribe(() => {
        client.Conventions.map(convention => {
          convention.displayed = false;
        });
      });
    });
  }

  public CloseAll(): void {
    this.clients.map(client => {
      client.displayed = false;
        client.Conventions.map(convention => {
          convention.displayed = false;
        });
    });
  }

  public ClearFilterInput(input: any): void {
    input.focus();
    this.inputClientsValue = '';
  }
 
}
